export const TAG_ARRAY = ["Signal", "Telecom", "Track"];

export const TAGS = {
  Signal: { name: "Signal", color: "#2A5FC8" },
  Track: { name: "Track", color: "#7A230B" },
  Telecom: { name: "Telecom", color: "blue" }
};
